// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3biiX","label":"styles_label__2DNfH"};